import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Group } from '../../models/group';
import { ToastsManager } from 'ng2-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GroupService } from '../../services/group.service';
import { AccountDTO } from '../../models/account';
import { AccountService } from '../../services/account.service';
import { Roles } from '../../models/roles';
import { ContractService } from '../../services/contract.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-groups-form',
  templateUrl: './groups-form.component.html',
  styleUrls: ['./groups-form.component.css']
})
export class GroupsFormComponent implements OnInit {

  grp: Group;
  creationMode: boolean;
  visibleGroups: Group[];  // list of group used for display parent group
  parentGroupId = 0; // 0 => invalid value (corresponds to no parent group)

  admin: AccountDTO[]; // list of administrators for the current group
  maintainers: AccountDTO[]; // list of maintainers for the current group

  showAddAdmin = false;
  showAddMaintainer = false;

  // mail of admin and maintainer to add
  adminMail: string;
  maintainerMail: string;

  @Output() onUpdateValidation = new EventEmitter<Group>();
  @Output() onCreateValidation = new EventEmitter<boolean>();

  constructor(private toast: ToastsManager,
              public activeModal: NgbActiveModal,
              private groupService: GroupService,
              private contractService: ContractService,
              private accountService: AccountService,
              public translate: TranslateService) { }

  ngOnInit() {
    if (!this.creationMode) {
      // retrieve admin and maintainers accounts
      this.accountService.getAccountByGroupAndType(this.grp.id, Roles.ADMIN).subscribe(res => this.admin = res.res);
      this.accountService.getAccountByGroupAndType(this.grp.id, Roles.MAINTAINER).subscribe(res => this.maintainers = res.res);

      if (this.grp.parentId) {
        this.parentGroupId = this.grp.parentId;
      }
    }
    this.groupService.loadVisibleGroups().subscribe(res => this.visibleGroups = res.filter(g => g.id !== this.grp.id));

  }

  changeFreeFloating(value: boolean) {
    this.grp.freeFloatingEnabled = value;
  }

  addAdmin() {
    this.showAddAdmin = true;
  }

  addMaintainer() {
    this.showAddMaintainer = true;
  }

  onSaveClick(close?: boolean) {
    if (this.parentGroupId !== 0) {
      this.grp.parentId = this.parentGroupId;
    } else {
      this.grp.parentId = undefined;
    }

    if (this.creationMode) {
      // first we save the group in the database
      this.groupService.post(this.grp).subscribe(res => {
        this.toast.success(this.translate.instant('toast.grpcreated'), this.translate.instant('toast.success'));
        this.grp = res;

        // offer the possibility to add maint/admin
        this.onCreateValidation.emit(true);
        if (close) {
          this.activeModal.close();
        } else {
          this.creationMode = false;
        }
      });

    } else {
      this.groupService.update(this.grp).subscribe(res => {
        this.toast.success(this.translate.instant('toast.grpupdated'), this.translate.instant('toast.success'));
        this.onUpdateValidation.emit(res);
        this.activeModal.close();
      });
    }
  }

  onClickAddAdmin() {
    this.contractService.createContract(this.grp.id, this.adminMail, Roles.ADMIN, null).subscribe(res => {
      this.adminMail = '';
      this.toast.success(this.translate.instant(
        'toast.emailSentToAdmin',
        {'adminMail' : this.adminMail}),
        this.translate.instant('toast.success')
      );
      this.showAddAdmin = false;
    });
  }

  onClickAddMaintainer() {
    this.contractService.createContract(this.grp.id, this.maintainerMail, Roles.MAINTAINER, null).subscribe(res => {
      this.toast.success(this.translate.instant(
        'toast.emailSentToMaintainer',
        {'maintainerMail' : this.maintainerMail}),
        this.translate.instant('toast.success')
      );
      this.maintainerMail = '';
      this.showAddMaintainer = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/groups/groups-form/groups-form.component.ts